export const getBlurText = (text, blur) => {
  if (blur) {
    return `<div class="blur-out">${text}</div>`;
  }
  return text;
};

export const BlurContent = ({ children, blur }) => {
  if (blur) {
    return <div className="blur-out">{children}</div>;
  }
  return children;
};
